<div class="wrapper">

  <div class="message-container">
    @for (message of messageService.messages; track message) {
      <div class="alert alert-{{message.type}}">
        <div class="d-flex justify-content-between">
          <div class="text-message">
            {{ message.text }}
          </div>
          <div class="ms-2">
            <button type="button"
              (click)="messageService.messages.splice(messageService.messages.indexOf(message), 1)"
            class="btn-close"></button>
          </div>
        </div>
      </div>
    }
  </div>

  <main class="main" id="top">
    <nav class="navbar navbar-vertical navbar-expand-lg">
      <div class="collapse navbar-collapse" id="navbarVerticalCollapse">
        <div class="navbar-vertical-content">
          <ul class="navbar-nav flex-column">
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('dashboard')}"
                  [routerLink]="['/dashboard']">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-indicator-icon">

                    </div>
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-gauge-high"></i>
                    </span>
                    <span class="nav-link-text">Дашбоард</span>
                  </div>
                </a>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link dropdown-indicator label-1 collapsed" role="button" href="#products"
                  data-bs-toggle="collapse" [attr.aria-expanded]="isActive('products')"
                  aria-controls="products">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-indicator-icon">
                      <i class="fa-solid fa-caret-right"></i>
                    </div>
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-cube"></i>
                    </span>
                    <span class="nav-link-text">Товары</span>
                  </div>
                </a>
                <div class="parent-wrapper label-1">
                  <ul class="nav parent collapsed collapse" id="products"
                    [ngClass]="{'show': isActive('products')}">
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{'active': isActive('products/links')}"
                        [routerLink]="['/products/links']">
                        <div class="d-flex align-items-center">
                          <span class="nav-link-icon">
                            <i class="fa-solid fa-link"></i>
                          </span>
                          <span class="nav-link-text">Сопутствующие</span>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{'active': isActive('products/sort')}"
                        [routerLink]="['/products/sort']">
                        <div class="d-flex align-items-center">
                          <span class="nav-link-icon">
                            <i class="fa-solid fa-arrow-down-1-9"></i>
                          </span>
                          <span class="nav-link-text">Сортировка</span>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{'active': isActive('products/filters')}"
                        [routerLink]="['/products/filters']">
                        <div class="d-flex align-items-center">
                          <span class="nav-link-icon">
                            <i class="fa-solid fa-filter"></i>
                          </span>
                          <span class="nav-link-text">Сортировка фильтров</span>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('cities')}"
                  [routerLink]="['/cities']">
                  <div class="d-flex align-items-center">
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-city"></i>
                    </span>
                    <span class="nav-link-text">Города</span>
                  </div>
                </a>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link dropdown-indicator label-1 collapsed" role="button" href="#stores"
                  data-bs-toggle="collapse" [attr.aria-expanded]="isActive('stores')"
                  aria-controls="stores">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-indicator-icon">
                      <i class="fa-solid fa-caret-right"></i>
                    </div>
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-shop"></i>
                    </span>
                    <span class="nav-link-text">Магазины</span>
                  </div>
                </a>
                <div class="parent-wrapper label-1">
                  <ul class="nav parent collapsed collapse" id="stores"
                    [ngClass]="{'show': isActive('stores')}">
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{'active': isActive('stores/list')}"
                        [routerLink]="['/stores/list']">
                        <div class="d-flex align-items-center">
                          <span class="nav-link-icon">
                            <i class="fa-solid fa-list"></i>
                          </span>
                          <span class="nav-link-text">Список</span>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{'active': isActive('stores/promotions')}"
                        [routerLink]="['/stores/promotions']">
                        <div class="d-flex align-items-center">
                          <span class="nav-link-icon">
                            <i class="fa-solid fa-bolt"></i>
                          </span>
                          <span class="nav-link-text">Акции</span>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('bartenders')}"
                  [routerLink]="['/bartenders']">
                  <div class="d-flex align-items-center">
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-person-harassing"></i>
                    </span>
                    <span class="nav-link-text">Бармены</span>
                  </div>
                </a>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('slider')}"
                  [routerLink]="['/slider']">
                  <div class="d-flex align-items-center">
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-images"></i>
                    </span>
                    <span class="nav-link-text">Слайдер</span>
                  </div>
                </a>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('stories')}"
                  [routerLink]="['/stories']">
                  <div class="d-flex align-items-center">
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-circle"></i>
                    </span>
                    <span class="nav-link-text">Сторис</span>
                  </div>
                </a>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('push')}" [routerLink]="['/push']">
                  <div class="d-flex align-items-center">
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-bell"></i>
                    </span>
                    <span class="nav-link-text">PUSH-уведомления</span>
                  </div>
                </a>
              </div>
            </li>
            <li class="nav-item">
              <div class="nav-item-wrapper">
                <a class="nav-link" [ngClass]="{'active': isActive('users')}" [routerLink]="['/users']">
                  <div class="d-flex align-items-center">
                    <span class="nav-link-icon">
                      <i class="fa-solid fa-users"></i>
                    </span>
                    <span class="nav-link-text">Пользователи</span>
                  </div>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <nav class="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
      <div class="collapse navbar-collapse justify-content-between">
        <div class="navbar-logo">
          <button class="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent" type="button"
            data-bs-toggle="collapse" data-bs-target="#navbarVerticalCollapse"
            aria-controls="navbarVerticalCollapse" aria-expanded="false"
            aria-label="Toggle Navigation"><span class="navbar-toggle-icon"><span
          class="toggle-line"></span></span></button>
          <a class="navbar-brand me-1 me-sm-3" [routerLink]="['/dashboard']">
            <img src="/template/img/ic_logo_dark.png" style="height: 45px;" />
          </a>
        </div>

        <ul class="navbar-nav navbar-nav-icons flex-row">
          <li class="nav-item cursor-pointer" (click)="signOut()">
            <app-icons name="logout" class="mb-1"></app-icons>&nbsp;<span>Выход</span>
          </li>
        </ul>
      </div>
    </nav>

    <div class="content">

      <ng-content></ng-content>

      <!-- <footer class="footer position-absolute">

    </footer> -->
  </div>
</main>

</div>